var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advert-loader"},[_c('div',[_c('img',{staticStyle:{"max-width":"300px"},attrs:{"src":require("../assets/images/not-found.gif"),"alt":""}}),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$store.getters.strings[_vm.$store.getters.currentLang].notFound))]),_c('br'),_c('br'),_c('br'),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }